export default __webpack_public_path__ + "static/media/ic-instruction-06.8fd26d37.svg";